import styled from 'styled-components/macro';

export const LogoHolder = styled.div`
  width: 220px;
  @media (min-width: 768px) {
   width: 220px;
  }
`;
export const Img = styled.img``;
